<template>
  <div class="inner">
    <div class="page_con">
      <div class="form_table">
        <div class="form">
          <ul class="form_ul">
            <li class="form_li">
              <div class="form_ttl">
                <p class="essen">교육 이수자 이름</p>
              </div>
              <div class="form_in">
                <div class="input">
                  <!-- 박스 잠금 (서남아이에스 임현아, 2024-11-14) -->
                  <input type="text" placeholder="이름을 입력해 주세요" v-model="form.userName" readonly disabled>
                  <p class="valid" :class="{ 'on' : $v.form.userName.$error }">필수입력사항입니다.</p><!--'on 추가'-->
                </div>
              </div>
            </li>
            <li class="form_li">
              <div class="form_ttl">
                <p class="essen">생년월일</p>
              </div>
              <div class="form_in">
                <div class="input">
                  <!-- 박스 잠금 (서남아이에스 임현아, 2024-11-14) -->
                  <input type="number" placeholder="생년월일을 입력해 주세요" v-model="form.birth" readonly disabled>
                  <p class="hint">
                    생년월일 8자리(ex: 20200131)를 입력해 주세요.
                  </p>
                  <p class="valid" :class="{'on' : $v.form.birth.$error}">필수입력사항입니다.</p><!--'on 추가'-->
                </div>
              </div>
            </li>
            <li class="form_li">
              <div class="form_ttl">
                <p>업종 분류</p>
              </div>
              <div class="form_in">
                <p class="bind">{{ $ConstCode.CODE_INDUSTRY_TYPE[eduType.industryType].name }}</p>
              </div>
            </li>
            <li class="form_li">
              <div class="form_ttl">
                <p class="essen">직책</p>
              </div>
              <div class="form_in">
                <div class="inline">
                  <div class="radio">
                    <input type="radio" name="a" id="aa" :value="1" v-model="form.positionType">
                    <label for="aa"><span>대표자</span></label>
                  </div>
                  <div class="radio">
                    <input type="radio" name="a" id="ab" :value="2" v-model="form.positionType">
                    <label for="ab"><span>위생관리자</span></label>
                  </div>
                </div>
                <p class="valid" :class="{'on' : $v.form.positionType.$error}">필수입력사항입니다.</p><!--'on 추가'-->
                <div class="inform_box">
                  <ol class="ol dot">
                    <li class="color">
                        <!-- 문구 변경 (서남아이에스 임현아, 2024-11-14) -->
                        <!-- <span class="ol_li_txt">
                            교육 이수자의 직책이 ‘위생관리자’인 경우,
                            ‘식품위생관리 책임자 지정확인서’를 제출해야합니다.<br>
                            <br>
                            지정확인서 안내 및 제출 방법 확인 경로: <br> 고객센터 > 공지사항 > 위생관리자 지정확인서
                        </span> -->
                        <span class="ol_li_txt">
                          교육 이수자의 직책이 <span class="ol_li_txt_span">‘위생관리자’</span>인 경우, <span class="ol_li_txt_span">‘식품위생관리 책임자 지정확인서’</span>를 제출해야 하며,<br>
                          위생관리자로 수강하는 경우 지자체에 <span class="ol_li_txt_span">영업신고 시 위생관리자의 보건증을 지참</span>해야 하는 점 참고 바랍니다.<br><br>
                          <!-- 한국외식산업협회 위생교육 지정확인서 제출 양식 버튼 (서남아이에스 임현아, 2024-11-14) -->
                          ※ 지정확인서 제출 방법 : <br>나의 학습방 ▶ 지정 확인서 제출
                        </span>
                    </li>
                  </ol>
                  <!-- 한국외식산업협회 위생교육 지정확인서 제출 양식 버튼 (서남아이에스 임현아, 2024-11-14) -->
                 <button class="btn" style="border: 0; border-radius: 0.5rem; background-color: #FF9F00;" @click="fnView">제출 양식 바로가기</button>
                </div>
              </div>
            </li>
            <li class="form_li">
              <div class="form_ttl">
                <p class="essen">휴대폰 번호</p>
              </div>
              <div class="form_in">
                <div class="input">
                  <!-- 박스 잠금 (서남아이에스 임현아, 2024-11-19) -->
                  <input type="number" placeholder="-를 제외하고 입력해 주세요" v-model="form.userPhone" disabled>
                  <p class="valid" :class="{'on' : $v.form.userPhone.$error }">필수입력사항입니다.</p><!--'on 추가'-->
                </div>
              </div>
            </li>
            <li class="form_li">
              <div class="form_ttl">
                <p class="essen">지역</p>
              </div>
              <div class="form_in">
                <div class="inline">
                  <div class="select">
                    <select name="" id="" v-model="form.location">
                      <option value="" disabled selected>선택</option>
                      <option v-for="item in $ConstCode.CODE_LOCATION"
                              :key="item.value"
                              :value="item.value">{{ item.name }}</option>
                    </select>
                  </div>
<!--                  <div class="datepicker-btn" v-show="isCalender" @click="fnEducation"></div>-->
                </div>
                <p class="valid" :class="{'on' : $v.form.location.$error }">필수입력사항입니다.</p><!--'on 추가'-->
              </div>
            </li>
            <li class="form_li" v-if="showSchedule">
              <div class="form_ttl">
                <p>집합 교육 일정</p>
              </div>
              <div class="form_in">
                <div class="m_table">
                  <div class="empty" v-if="$Util.isEmpty(schedule.list.location)">
                    <span>내역이 존재하지 않습니다.</span>
                  </div>
                  <ul class="m_table_ul" v-else>
                    <li class="m_table_li">
                      <div class="col">
                        <div class="m_table_ttl">
                          <span class="color">{{ $Util.isEmpty(schedule.edu.eduDate) ? '' : $moment(schedule.edu.eduDate).format('YYYY.MM.DD') }}｜{{ schedule.edu.startTime }}</span><br>
                          <span>{{ schedule.list.location }}</span>
                        </div>
                      </div>
                      <div class="col fix90">
                        <div class="be_left">
                          <span>신청가능</span><br>
                          <span class="be_left_nb">{{ (schedule.list.personnel - schedule.count) > 0 ? (schedule.list.personnel - schedule.count) : '0' }} 명</span>
                        </div>
                      </div>
<!--                      <div class="col fix52">-->
<!--                        <div class="radio">-->
<!--                          <input type="radio" name="b" :id="`b_${index}`" :value="item.edu.offlineEducationNo" @click="fnSelected(item)">-->
<!--                          <label :for="`b_${index}`"></label>-->
<!--                        </div>-->
<!--                      </div>-->
                    </li>
                  </ul>
                </div>
                <p class="valid" :class="{'on': $v.form.sceneNo.$error}">교육 일정을 선택해주세요.</p><!--'on 추가'-->
              </div>
            </li>
            <li class="form_li" v-if="eduType.salesType === 2">
              <div class="form_ttl">
                <p class="essen">인허가 번호</p>
              </div>
              <div class="form_in">
                <div class="inline">
                  <div class="input">
                    <input type="number" placeholder="번호를 입력해 주세요" v-model="form.licenseNumber" disabled>
                  </div>
                  <button class="btn bo" @click="fnLicense" @bindData="fnBindLicense">인허가 번호 검색</button>
                </div>
                <p class="hint">
                  인허가번호를 입력해 검색 후 해당 영업소를 선택하시면 아래 모든 항목이 자동으로 입력됩니다.
                </p>
                <p class="valid" :class="{'on' : $v.form.licenseNumber.$error}">필수입력사항입니다.</p><!--'on 추가'-->
              </div>
            </li>
            <li class="form_li">
              <div class="form_ttl">
                <p class="essen">영업소 &amp; 상호명 명칭</p>
              </div>
              <div class="form_in">
                <div class="input">
                  <input type="text" placeholder="명칭을 입력해 주세요" v-model="form.businessName" :disabled="eduType.salesType === 2">
                  <p class="hint" v-if="eduType.salesType === 1">
                    영업소 &amp; 상호명 명칭이 미정인 경우 입력란에 ‘미정’ 으로 적어주세요.
                    (추후 상호명 변경을 원하시면 1:1 게시판 및 신고센터에 문의하시기 바랍니다.)
                  </p>
                  <p class="valid" :class="{'on' : $v.form.businessName.$error}">필수입력사항입니다.</p><!--'on 추가'-->
                </div>
              </div>
            </li>
            <li class="form_li">
              <div class="form_ttl">
                <p class="essen">대표자 이름</p>
              </div>
              <div class="form_in">
                <div class="input">
                  <input type="text" placeholder="이름을 입력해 주세요" v-model="form.representative" :disabled="eduType.salesType === 2">
                  <p class="valid" :class="{'on' : $v.form.representative.$error }">필수입력사항입니다.</p><!--'on 추가'-->
                </div>
              </div>
            </li>
            <li class="form_li">
              <div class="form_ttl">
                <p class="essen">영업소 소재지</p>
              </div>
              <div class="form_in">
                <div class="inline">
                  <div class="input">
                    <input type="number" placeholder="우편 번호" v-model="form.postCode" disabled>
                  </div>
                  <button class="btn bo" @click="fnAddress" v-if="eduType.salesType === 1">주소 검색</button>
                </div>
                <div class="input">
                  <input type="text" placeholder="주소를 입력해 주세요" v-model="form.address" disabled>
                </div>
                <div class="input">
                  <input type="text" placeholder="상세주소를 입력해 주세요" v-model="form.address2">
                </div>
                <p class="valid" :class="{'on' : $v.form.address.$error }">필수입력사항입니다.</p><!--'on 추가'-->
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="page_btn">
      <button class="btn" @click="fnSave" :disabled="!form.isOver">{{ $ConstCode.CODE_SALES_TYPE[eduType.salesType].name }} 집합 위생교육 접수</button>
    </div>
    <top-button />
    <!-- 홈페이지 유지보수 개발요청안 | 푸터 배너 표출 (서남아이에스 임현아, 2024-07-20) -->
    <main-bottom-banner v-bind:isURL="isURL" />
  </div>
</template>

<script>
import TopButton from '@/components/pages/top/button'
import MainBottomBanner from '@/components/pages/main/bottombanner/index'
export default {
  name: 'online-apply-write',
  components: {TopButton, MainBottomBanner},
  props: {
    isCalender: {
      type: [Boolean],
      default: false
    },
    form: {
      type: [Object, Array],
      default: () => {}
    },
    $v: {
      type: [Object, Array],
      default: () => {}
    },
    eduType: {
      type: [Object, Array],
      default: () => {}
    },
    showSchedule: {
      type: [Boolean],
      default: false
    },
    schedule: {
      type: [Object, Array],
      default: () => {}
    }
  },
  data() {
    return {
      isURL: this.eduType.industryType === 1 ? '13' : (this.eduType.industryType === 2 ? '18': '23')
    }
  },
  watch: {
    'eduType.industryType': async function (){
      if (this.eduType.industryType === 1) {
        this.isURL = '13'
      }
      if (this.eduType.industryType === 2) {
        this.isURL = '18'
      }
      if (this.eduType.industryType === 3) {
        this.isURL = '23'
      }

      console.log(this.isURL)
    }
  },
  methods: {
    fnView: function() {
      this.$emit('eventView')
    },
    fnAddress: function () {
     this.$emit('eventAddress')
    },
    fnSave: function() {
      this.$emit('save')
    },
    fnLicense: function() {
      this.$emit('license')
    },
    fnBindLicense: function(item) {
      this.$emit('bindData', item)
    },
    fnLocation: function() {
      this.$emit('location')
    },
    fnSelected: function(item) {
      this.$emit('selected', item)
    },
    fnEducation: function() {
      this.$emit('education')
    }
  }
}
</script>

<style scoped>

</style>
